import React, { ReactElement, ReactNode } from 'react';
import config from '@/lib/config';
import './NoModule.scss';

const NoResult = ({ children }: { children?: ReactNode }): ReactElement => (
  <div className="no-elearning-module">
    <img src={`${config.assetPath}book.svg`} alt="book icon" />
    <h2>No modules to display</h2>
    {children}
  </div>
);

export default NoResult;
